<template>
  <svg
    class="custom-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M31.9998 25.5145V30.4909C32.0037 31.3244 31.3454 32.0041 30.5409 32H1.45886C0.653076 32.0041 -0.00392597 31.3231 1.76613e-05 30.4909V25.5145C1.76613e-05 25.2734 0.0711176 25.0542 0.168549 24.8526L3.07045 18.834C3.31667 18.3219 3.82227 18.0005 4.37131 18.0005H8.72953C10.715 17.9555 10.715 21.0554 8.72953 21.0091L5.27194 21.0104L3.81573 24.019H28.1921L26.7398 21.0104H23.2704C21.3758 21.0594 21.2376 18.1408 23.1322 18.0018H27.6327C28.1817 18.0059 28.6847 18.326 28.9309 18.8354L31.8328 24.854C31.9302 25.0542 31.9972 25.2748 31.9998 25.5145Z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22.5144 12.8754L16.9523 18.5854C16.4069 19.1382 15.534 19.1382 14.9887 18.5854L9.4227 12.8754C9.18717 12.6403 9.03855 12.3304 9.00704 11.992C8.93021 11.208 9.49071 10.5106 10.2552 10.4318C10.6772 10.3892 11.1004 10.548 11.3964 10.8645L14.5755 14.1282V1.45437C14.5629 0.661384 15.1813 0.00914571 15.9521 0.000119458C16.7393 -0.0102128 17.3742 0.651068 17.3615 1.45437V14.1411L20.5532 10.8644C20.5985 10.8076 20.6502 10.7559 20.7043 10.7094C21.2875 10.1967 22.1654 10.2665 22.6642 10.8644C23.1655 11.4637 23.0976 12.3627 22.5144 12.8754Z"
    />
  </svg>
</template>
